import React from 'react';
import { useTranslation } from 'react-i18next';

import ButtonStyled from '../button/Button';
import styles from './categoryInfo.module.scss';

export type CategoryInfoProps = {
  closeButtonHandler: () => void;
  title: string;
  body: string;
};

export const CategoryInfo: React.FC<CategoryInfoProps> = ({
  closeButtonHandler,
  title,
  body,
}) => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.popup} data-testid="categoryInfo">
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.description}>{body}</p>

      <ButtonStyled onClick={closeButtonHandler} ariaLabel="Close">
        {t('labels.close')}
      </ButtonStyled>
    </div>
  );
};
